<div>
	<h1 class="typography--display1">School Detail</h1>
	<h2 class="typography--headline">{{ longName }}</h2>
	<dl class="definitions--inline">
		<dt>School ID</dt>
		<dd>{{ id }}</dd>
	</dl>
</div>
